import type { DefineComponent } from "vue"

import * as Sentry from "@sentry/vue"

import PrimeVue from "primevue/config"
import { definePreset } from "@primeuix/themes"
import Aura from "@primeuix/themes/aura"

import { createVueTranslate } from "@hakunajs/vue-translate"
import datetimeFormats from "~/locales/datetimeFormats"
import globalTranslations from "~/locales/globalTranslations"

const ThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
  },
})

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>("../../pages/Public/**/*.vue", {
      eager: true,
    })
    let page = pages[`../../pages/${name}.vue`]

    if (!page) {
      throw `Missing Inertia page component: '${name}.vue'`
    }
    return page
  },
  setup({ el, App, props, plugin }) {
    const i18n = createVueTranslate({
      locale: "de",
      availableLocales: ["de"],
      formats: datetimeFormats,
      messages: globalTranslations,
      showMissingTranslationWarnings: true,
    })

    const app = createApp({ render: () => h(App, props) })

    Sentry.init({
      app,
      dsn: import.meta.env.SENTRY_DSN,
      environment: import.meta.env.SENTRY_ENVIRONMENT,
      release: import.meta.env.SENTRY_RELEASE,
    })

    app
      .use(plugin)
      .use(i18n)
      .use(PrimeVue, {
        theme: {
          preset: ThemePreset,
          options: {
            darkModeSelector: false,
            cssLayer: {
              name: "primevue",
              order: "theme, base, primevue",
            },
          },
        },
      })
      .mount(el)
  },
}).then(() => {
  // document.getElementById('app')?.removeAttribute('data-page');
})
